<template>
    <div class="row">
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">Groups</h3>
                    <div class="box-tools pull-right">
                        <button
                            class="btn btn-box-tool"
                            title="Collapse"
                            type="button"
                            @click="collapse = !collapse"
                        >
                            <i :class="[collapse ? 'fa-minus' : 'fa-plus']" class="fa"></i>
                        </button>
                    </div>
                </div>
                <vue-slide-up-down
                    :active="collapse"
                    :duration="collapseDuration"
                >
                    <div v-if="loadingData">
                        <div class="text-center">
                            <img alt="Preloader" class="table-row-preloader" rel="preload" src="/img/table-row-preloader.gif"/>
                        </div>
                    </div>
                    <div v-else class="box-body table-responsive no-padding">
                        <table class="table table-hover offers-table">
                            <thead>
                            <tr>
                                <th class="text-left">ID</th>
                                <th class="text-left">Name</th>
                                <th class="text-left">Stats</th>
                                <th class="text-right open-all">
                                    <span
                                        class="btn btn-sm btn-primary"
                                        @click="triggerAll"
                                    >
                                        <i :class="collapseAllGroups ? 'fa-caret-up' : 'fa-caret-down'" class="fa"></i>
                                        <span class="sr-only">Show All</span>
                                    </span>
                                </th>
                            </tr>
                            </thead>
                            <group-component
                                v-for="group in ipGroups" :key="group.id"
                                :ips="ips"
                                :ipGroups="ipGroups"
                                :group="group"
                                :collapse="collapseGroups[group.id]"
                                @toggleGroup="toggleGroup"
                            />
                        </table>
                    </div>
                </vue-slide-up-down>
            </div>
        </div>
    </div>
</template>

<script>
import GroupsStatsComponent from "./GroupsStatsComponent";
import GroupComponent from "./GroupComponent";

export default {
    props: {
        ips: Array,
        ipGroups: Array
    },
    data() {
        return {
            collapseDuration: 700,
            collapse: true,
            collapseAllGroups: false,
            collapseGroups: {},
        }
    },
    methods: {
        triggerAll() {
            this.collapseAllGroups = !this.collapseAllGroups;
            this.ipGroups.forEach((item) => {
                this.$set(this.collapseGroups, item.id, this.collapseAllGroups);
            });
        },
        toggleGroup(groupId) {
            this.collapseGroups[groupId] = this.collapseGroups[groupId] === undefined
                ? this.$set(this.collapseGroups, groupId, true)
                : this.$set(this.collapseGroups, groupId, !this.collapseGroups[groupId]);

            let stateCollapseGroups = {
                close: 0,
                open: 0
            }
            this.ipGroups.forEach((item) => {
                this.collapseGroups[item.id] ? stateCollapseGroups.open++ : stateCollapseGroups.close++;
            });
            this.ipGroups.length === stateCollapseGroups.open && (this.collapseAllGroups = true);
            this.ipGroups.length === stateCollapseGroups.close && (this.collapseAllGroups = false);
        }
    },
    computed: {
        loadingData: function () {
            return !this.ips || !this.ipGroups;
        }
    },
    components: {
        GroupsStatsComponent,
        GroupComponent
    }
}
</script>
<style scoped>
.table-responsive {
    overflow: visible;
}
</style>
